import React, { Component } from 'react';
import Footer from '../components/organisms/Footer';
import OrderStepper from '../utils/OrderStepper';
import cssVars from '../assets/export.css';
import AppMessage from '../utils/AppMessage';
import LoadingBar from 'react-redux-loading-bar';
import schoolTabLogo from '../assets/images/schooltab_logo.png';
import SectionIncomplete from '../utils/SectionIncomplete';
import PayeverObserver from '../utils/PayeverObserver';
import TextOverlay from '../utils/TextOverlay';
import SerialHelpOverlay from '../utils/SerialHelpOverlay';
import NextStep from '../utils/NextStep';
import './styles/all.css';



const loadingBarStyle = {
  backgroundColor: cssVars.brandPrimary,
  height: '3px'
};


class Scaffolding extends Component {

  render() {
    
    return (
      <div className="scaffolding" id="outer-container" key="outer-container">
      <AppMessage />
      <LoadingBar style={loadingBarStyle} showFastActions />

      <div id="wrapper">
        <div id="inner">
          <div id="logo">
            <img id="schooltablogo" alt="schooltab" src={schoolTabLogo} />
          </div>
          <div id="schooltabcontent">
            <SectionIncomplete key="sectionincomplete" />
            <TextOverlay key="textoverlay" />
            <SerialHelpOverlay key="snoverlay" />
            <PayeverObserver key="payeverobserver" />
            <OrderStepper key="orderstepper"  />
            {this.props.children}
            <NextStep key="nextstep" />
          </div>
        </div>
      </div>
      <Footer />
      </div>

    );

  }

}



export default Scaffolding



// WEBPACK FOOTER //
// ./src/views/Scaffolding.js